export function isDefined(element: any): boolean {
    return element ?? false;
}
